import AppCatalog from "../../services/App/AppCatalog.js";

export default {
  InvoicePrintNote: {
    Label: AppCatalog.Field.Comment.Label + " Tambahan",
    Type: AppCatalog.Field.Comment.Type,
    ReadOnly: true
  }
}